import * as TypAutentizace from 'mc/lib/api/gen/ucty/v1/TypAutentizace';
import React from "react";

const captions = {
    [TypAutentizace.JMENO_HESLO]: "TypAutentizace_JMENO_HESLO",
    [TypAutentizace.NIA]: "TypAutentizace_NIA",
    [TypAutentizace.MOJE_ID]: "TypAutentizace_MOJE_ID",
    [TypAutentizace.ISDS]: "TypAutentizace_ISDS",
};

const nepripojenCaptions = {
    [TypAutentizace.JMENO_HESLO]: "TypAutentizace_JMENO_HESLO_INVALID",
    [TypAutentizace.NIA]: "TypAutentizace_NIA_INVALID",
    [TypAutentizace.MOJE_ID]: "TypAutentizace_MOJE_ID_INVALID",
    [TypAutentizace.ISDS]:  "TypAutentizace_ISDS_INVALID",
};

export function getCaption(value) {
    return captions[value];
}

export function getNepripojenoCaption(value) {
    return nepripojenCaptions[value];
}
